import React from 'react'
import Dashboard from '../sections/services/Dashboard'
import ServicesComp from '../sections/services/Services'
import Footer from '../layout/footer'
import Reviews from '../sections/review/Reviews'
import { Helmet } from 'react-helmet'


const Services = () => {
  return (
    <div id='page'>
            <Helmet>
        <title>Vwrap | Advertisement Services</title>
        <meta name="description" content="Vwrap offers a comprehensive array of services, running marketing campaigns through effective methods from vinyl designing to on-vehicle and outdoor marketing!" />
      </Helmet>
      <Dashboard />
      <ServicesComp />
      <Reviews />
      <Footer />
    </div>
  )
}

export default Services
